module.exports = __webpack_public_path__ + "images/206726365ac4dac71bba35af3a0bfd84.png";